module.exports = __webpack_public_path__ + "img/tu3.794c8a6c.png";